import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_AFFILIATE_PROGRAM_ADMIN_FEES = Symbol('affiliate-program.admin-fees');

export const AFFILIATE_PROGRAM_ADMIN_FEES_ROUTE_NAME = Symbol('affiliate-program.admin-fees');

export const AFFILIATE_PROGRAM_SHOW_ADMIN_FEES_API_URL = 'admin/history_of_admin_fees_changes/form_data';
export const AFFILIATE_PROGRAM_SHOW_ADMIN_FEES_QUERY_KEY = 'affiliate-program.admin-fees.show';

export const AFFILIATE_PROGRAM_ADMIN_FEES_MERCHANTS_QUERY_KEY = 'affiliate-program.admin-fees.merchants';
export const AFFILIATE_PROGRAM_ADMIN_FEES_MERCHANTS_API_URL = 'admin/history_of_admin_fees_changes/list_merchants';

export const AFFILIATE_PROGRAM_ADMIN_FEES_HISTORY_LIST_QUERY_KEY = 'affiliate-program.admin-fees.history-list';
export const AFFILIATE_PROGRAM_ADMIN_FEES_HISTORY_LIST_API_URL = 'admin/history_of_admin_fees_changes/list';

export const AFFILIATE_PROGRAM_SAVE_ADMIN_FEES_MUTATION = 'affiliate-program.admin-fees.save';
export const AFFILIATE_PROGRAM_SAVE_ADMIN_FEES_API_URL = 'admin/history_of_admin_fees_changes/:id';

export const AFFILIATE_PROGRAM_DELETE_ADMIN_FEES_MUTATION = 'affiliate-program.admin-fees.delete';
export const AFFILIATE_PROGRAM_DELETE_ADMIN_FEES_API_URL = 'admin/history_of_admin_fees_changes/:id';

export const AFFILIATE_PROGRAM_ADMIN_FEES_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.HISTORY_OF_ADMIN_FEES_CHANGES_SHOW),
  CREATE: new Permission(PermissionsList.admin.HISTORY_OF_ADMIN_FEES_CHANGES_CREATE),
  EDIT: new Permission(PermissionsList.admin.HISTORY_OF_ADMIN_FEES_CHANGES_EDIT),
  DELETE: new Permission(PermissionsList.admin.HISTORY_OF_ADMIN_FEES_CHANGES_DELETE),
};
